import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { motion } from "framer-motion";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix default icon issue in Leaflet + React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// ================= Animations =================

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const zoomIn = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const MapSection = () => {
  const center = [33.6844, 73.0479]; // Islamabad

  return (
    <section className="bg-gray-50 pt-14 lg:pb-16 lg:pt-6 px-4 sm:px-6 lg:px-12 overflow-hidden">
      <motion.div
        className="max-w-[90vw] mx-auto"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {/* ================= Header ================= */}
                  <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, ease: "easeOut" }}
                            className="text-center mb-8 lg:mb-16"
                          >
                            <h2 className="text-center text-3xl md:text-4xl font-extrabold tracking-tight text-transparent bg-clip-text bg-[var(--bg-primary)] drop-shadow-sm mb-2 lg:mb-2">
                             Find Us Here
                            </h2>
                            <div className="w-40 h-1 bg-[var(--bg-primary)] mx-auto rounded-full mb-2"></div>
                            <p className="text-sm md:text-sm text-gray-500 text-center max-w-md mx-auto">
                                 Connect with us in person and discover how we can help bring your ideas to life.
                            </p>
                          </motion.div>

        {/* ================= Map ================= */}
        <motion.div
          variants={zoomIn}
          whileHover={{ scale: 1.01 }}
          transition={{ type: "spring", stiffness: 120, damping: 15 }}
          className="relative h-[450px] w-full rounded-3xl overflow-hidden shadow-2xl border border-gray-200 group"
        >
          {/* glow overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-transparent to-purple-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-10" />

          <MapContainer
            center={center}
            zoom={13}
            style={{ height: "100%", width: "100%" }}
            zoomControl={false}
            className="z-0"
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            <Marker position={center}>
              <Popup>
                <div className="text-center font-sans">
                  <strong className="block mb-1 text-[var(--bg-primary)]">
                    MBA Solutions
                  </strong>
                  <span className="text-sm text-gray-600">
                    Blue Area, Islamabad, Pakistan
                  </span>
                </div>
              </Popup>
            </Marker>
          </MapContainer>
        </motion.div>

        {/* ================= Info Cards ================= */}
        <motion.div
          variants={containerVariants}
          className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 text-center"
        >
          {[
            { label: "Email Us", value: "info@mbasolutions.com" },
            { label: "Call Us", value: "+92 300 1234567" },
            { label: "Visit Us", value: "Blue Area, Islamabad" },
          ].map((item, index) => (
            <motion.div
              key={index}
              variants={fadeUp}
              whileHover={{
                y: -8,
                scale: 1.05,
              }}
              transition={{ type: "spring", stiffness: 220, damping: 14 }}
              className="relative bg-white p-6 rounded-2xl shadow-md border border-gray-100 overflow-hidden group cursor-pointer"
            >
              {/* hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-transparent to-purple-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <p className="relative text-gray-500 text-sm mb-1 transition-colors duration-300 group-hover:text-[var(--text-primary)]">
                {item.label}
              </p>
              <p className="relative font-semibold text-gray-900">
                {item.value}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default MapSection;
